import api from "./client";

/* Team — the people-management reads/writes behind the ONE employee card
   (EmployeePopup) and the Team-level tabs. All of these are lane D's
   endpoints on the EmploymentProfile anchor, plus StoredFile for documents.
   The card and the tabs read the same stores; nothing here has a second copy. */

// Roster + the per-person join (credentials, licensed_for, skills, time_off, training, comp)
export const listEmployees = () => api.get("/people/employees/");
export const getEmployee = (employeeId) => api.get(`/people/employees/${employeeId}/`);

// Training — course completions (POST is admin/manager)
export const listTraining = (params = {}) => api.get("/people/training/", { params });
export const createTraining = (body) => api.post("/people/training/", body);

// Onboarding checklist per employee (items derived from the compliance pack + docs + acknowledgements)
export const getOnboarding = (employeeId) => api.get(`/people/onboarding/${employeeId}/`);
// All checklists in one call (Team → Onboarding). 404 until the backend that adds it is deployed.
export const listOnboarding = () => api.get("/people/onboarding/");
export const completeOnboardingItem = (employeeId, itemKey, body = {}) =>
  api.post(`/people/onboarding/${employeeId}/items/${encodeURIComponent(itemKey)}/complete/`, body);

// Employee documents — StoredFile with owner_type=employee, owner_id=<user id>
export const listEmployeeDocs = (userId, params = {}) =>
  api.get("/storage/files/", { params: { owner_type: "employee", owner_id: userId, ...params } });
// StoredFile.category is a fixed backend list; the employee doc TYPE (tax form,
// license, agreement…) rides in metadata.doc_type (backend keeps it on upload).
export const uploadEmployeeDoc = (userId, file, docType = "document") => {
  const form = new FormData();
  form.append("file", file);
  form.append("category", docType === "w9" ? "w9" : "document");
  form.append("doc_type", docType);
  form.append("owner_type", "employee");
  form.append("owner_id", String(userId));
  return api.post("/storage/files/", form, { headers: { "Content-Type": "multipart/form-data" } });
};
export const deleteEmployeeDoc = (fileUuid) => api.delete(`/storage/files/${fileUuid}/`);

// Compliance (tenant-level overview: requirement checklist + held credentials + risks)
export const getComplianceOverview = () => api.get("/compliance/overview/");

// Technician profiles (TechnicianProfile id ↔ user) — time-off rows key on the profile
export const listTechnicianProfiles = () => api.get("/scheduling/technicians/");

export const DOC_CATEGORIES = [
  ["i9", "I-9"], ["w4", "W-4"], ["w9", "W-9"], ["direct_deposit", "Direct deposit"], ["void_check", "Voided check"],
  ["drivers_license", "Driver’s license"], ["license", "Professional license"], ["certification", "Certification"],
  ["insurance_card", "Insurance card"], ["emergency_contact", "Emergency contact"], ["contract", "Employment contract"],
  ["agreement", "Agreement"], ["training", "Training record"], ["safety", "Safety document"], ["document", "Other"],
];
export const docType = (f) => f?.metadata?.doc_type || (f?.category && f.category !== "document" ? f.category : "");
export const docName = (f) => f?.name || f?.original_name || f?.filename || f?.file_name || f?.title || "document";
export const docUrl = (f) => f?.get_url || f?.download_url || f?.url || f?.file_url || null;
export const techUserId = (t) => Number(t?.user_id ?? t?.user?.id ?? (typeof t?.user === "number" ? t.user : null)) || null;

// Training Phase 1 — SOP as required reading (crm_backend docs/TRAINING_SPEC.md).
// No new model: an assignment is onboarding signature steps carrying sop_slug,
// and completing one records the version-pinned SOPAcknowledgment.
export const listRequiredReading = () => api.get("/people/training/assignments/");
export const assignSops = (body) => api.post("/people/training/assign-sops/", body);
